import { HeaderDataProps } from "../components/organisms/Header/types";
import avatar from "../assets/img/person.jpeg";
const header: HeaderDataProps = {
  name: "Abdullah Khan",
  profilePicture: avatar,
  job: "Software Engineer",
};

export default header;
